import React from "react";

import { Helmet } from "react-helmet";

import MobileNabvar from "../components/mobile-nabvar";
import Slider from "../components/slider";
import "./home.css";

const Home = (props) => {
  return (
    <div className="home-container">
      <Helmet>
        <title>Economia da Cooperação</title>
        <meta property="og:title" content="Economia da Cooperação" />
      </Helmet>
      <div className="home-videos">
        <div className="home-container01">
          <div className="home-container02">
            <iframe
              src="https://www.youtube.com/embed/gvN3SA3CaWE?si=QO53hjv0rVkxzAFE"
              className="home-iframe"
            ></iframe>
          </div>
          <div className="home-container03">
            <iframe
              src="https://www.youtube.com/embed/gvN3SA3CaWE?si=QO53hjv0rVkxzAFE"
              className="home-iframe1"
            ></iframe>
          </div>
        </div>
      </div>
      <div className="home-acessibilidade">
        <div className="home-container04">
          <a
            href="https://www.viacredi.coop.br/sobre-acessibilidade"
            target="_blank"
            rel="noreferrer noopener"
            className="home-link OpenSans-T4"
          >
            ACESSIBILIDADE
          </a>
        </div>
      </div>
      <MobileNabvar rootClassName="mobile-nabvar-root-class-name"></MobileNabvar>
      <div className="home-header">
        <div className="home-inner">
          <div className="home-container05">
            <a
              href="https://www.viacredi.coop.br/"
              target="_blank"
              rel="noreferrer noopener"
              className="home-link01"
            >
              <img
                alt="image"
                src="/lp/economiadacooperacao/logo-viacredi.svg"
                className="home-image"
              />
            </a>
            <a
              href="https://www.viacredi.coop.br/sua-cooperativa/sistema-ailos"
              target="_blank"
              rel="noreferrer noopener"
              className="home-link02 OpenSans-T4"
            >
              Sistema Ailos
            </a>
            <a
              href="https://blog.ailos.coop.br/"
              target="_blank"
              rel="noreferrer noopener"
              className="home-link03 OpenSans-T4"
            >
              Blog
            </a>
          </div>
          <div className="home-container06">
            <a
              href="https://contaonline.viacredi.coop.br/ib/auth"
              target="_blank"
              rel="noreferrer noopener"
              className="home-link04"
            >
              <div className="home-container07">
                <span className="home-text OpenSans-T4">ACESSAR SUA CONTA</span>
              </div>
            </a>
            <a
              href="https://www.viacredi.coop.br/seja-um-cooperado"
              target="_blank"
              rel="noreferrer noopener"
              className="home-link05"
            >
              <div className="home-container08">
                <span className="home-text001 OpenSans-T4">SEJA COOPERADO</span>
              </div>
            </a>
          </div>
        </div>
      </div>
      <div className="home-hero">
        <div className="home-hero1 BoxShadow">
          <div className="home-container09 thq-section-max-width">
            <div className="home-container10">
              <div className="home-container11">
                <img
                  alt="image"
                  src="/lp/economiadacooperacao/assinatura%201-1600w.png"
                  className="home-image01"
                />
              </div>
              <span className="home-text002 Exo2-H6">
                <span className="home-text003">Na Viacredi</span>
                <span>
                  , quanto mais você participa, mais economiza e
                  <span
                    dangerouslySetInnerHTML={{
                      __html: " ",
                    }}
                  />
                </span>
                <span className="home-text005">
                  fortalece toda a comunidade
                </span>
              </span>
            </div>
            <div className="home-backup">
              <img
                alt="image"
                src="/lp/economiadacooperacao/Hero/modelo%20circular%20completo-600h.png"
                className="home-image02 Rotating"
              />
              <img
                alt="image"
                src="/lp/economiadacooperacao/Hero/modelo%20hero%20new-600h.png"
                className="home-image03"
              />
              <img
                alt="image"
                src="/lp/economiadacooperacao/ele%20bola%20gradiente%201-600h.png"
                className="home-image04 ElementoHoverDireita"
              />
              <img
                alt="image"
                src="/lp/economiadacooperacao/ele%20bola%20gradiente%203-600h.png"
                className="home-image05 ElementoHoverDireita"
              />
              <img
                alt="image"
                src="/lp/economiadacooperacao/ele%20bola%20gradiente%202-600h.png"
                className="home-image06 ElementoHoverEsquerda"
              />
              <img
                alt="image"
                src="/lp/economiadacooperacao/Hero/modelo%20new-600h.png"
                className="home-image07"
              />
            </div>
            <div className="home-container12">
              <img
                alt="image"
                src="/lp/economiadacooperacao/Hero/modelo%20circular%20completo-600h.png"
                className="home-image08 Rotating"
              />
              <img
                alt="image"
                src="/lp/economiadacooperacao/ele%20bola%20gradiente%201-600h.png"
                className="home-image09"
              />
              <img
                alt="image"
                src="/lp/economiadacooperacao/ele%20bola%20gradiente%203-600h.png"
                className="home-image10"
              />
              <img
                alt="image"
                src="/lp/economiadacooperacao/ele%20bola%20gradiente%202-600h.png"
                className="home-image11"
              />
              <img
                alt="image"
                src="/lp/economiadacooperacao/Hero/modelo-600h.png"
                className="home-image12"
              />
            </div>
          </div>
        </div>
      </div>
      <div className="home-hero-mobile BoxShadow">
        <div className="home-container13 thq-section-max-width">
          <div className="home-container14">
            <div className="home-container15">
              <img
                alt="image"
                src="/lp/economiadacooperacao/assinatura%201-1600w.png"
                className="home-image13"
              />
            </div>
            <span className="home-text006 Exo2-H6">
              <span className="home-text007">
                Na Viacredi você encontra produtos e serviços seguros e
                personalizados para realizar os seus sonhos.
              </span>
              <span>
                {" "}
                E ainda conta com um atendimento próximo e acolhedor para
                entender a real necessidade de cada momento da sua vida.
              </span>
            </span>
          </div>
        </div>
      </div>
      <div className="home-seo-1">
        <div className="home-container16 BoxShadow">
          <div className="home-container17"></div>
          <div className="home-separador"></div>
          <div className="home-container18">
            <img
              alt="image"
              src="/lp/economiadacooperacao/Secao2/2%20bilhoes-300h.png"
              className="home-image14"
            />
            <span className="home-text009 Exo2-T1">
              Este foi o resultado da nossa Economia da Cooperação em 2023
            </span>
          </div>
        </div>
        <div className="home-container19">
          <img
            alt="image"
            src="/lp/economiadacooperacao/ele%20bola%20gradiente%203-600h.png"
            className="home-image15 ElementoHoverEsquerda"
          />
          <img
            alt="image"
            src="/lp/economiadacooperacao/ele%20bola%20gradiente%203-600h.png"
            className="home-image16 ElementoHoverDireita"
          />
          <img
            alt="image"
            src="/lp/economiadacooperacao/ele%20bola%20gradiente%201-600h.png"
            className="home-image17 ElementoHoverEsquerda"
          />
          <img
            alt="image"
            src="/lp/economiadacooperacao/ele%20bola%20gradiente%202-600h.png"
            className="home-image18 ElementoHoverDireita"
          />
        </div>
      </div>
      <div className="home-seo-2">
        <div className="home-container20">
          <div className="home-container21">
            <span className="home-text010 Exo2-H5">Como isso é possível?</span>
            <span className="home-text011 Exo2-T2">
              Sempre que você escolhe a Viacredi para realizar suas operações
              financeiras, você está contribuindo com a Economia da Cooperação.
            </span>
          </div>
          <Slider rootClassName="slider-root-class-name"></Slider>
          <div className="home-container22">
            <div className="home-container23">
              <span className="Exo2-H5 home-text012">
                01.
                <span
                  dangerouslySetInnerHTML={{
                    __html: " ",
                  }}
                />
              </span>
              <span className="Exo2-T3 home-text013">
                Soluções financeiras completas para você, que tem muito a
                conquistar! 
              </span>
              <span className="Exo2-T4 home-text014">
                Com a Economia da Cooperação, você tem produtos e serviços
                seguros e personalizados à sua disposição. E conta ainda com um
                atendimento próximo e acolhedor para atender à real necessidade
                de cada momento da sua vida. É a sua chance de realizar os seus
                sonhos.
              </span>
            </div>
            <div className="home-container24">
              <span className="Exo2-H5 home-text015">
                02.
                <span
                  dangerouslySetInnerHTML={{
                    __html: " ",
                  }}
                />
              </span>
              <span className="Exo2-T3 home-text016">
                Economize e tenha mais rentabilidade com a Cooperativa
              </span>
              <span className="Exo2-T4 home-text017">
                Todos os anos realizamos uma pesquisa para saber a diferença de
                taxas, tarifas, juros e rentabilidade da Viacredi quando
                comparada às demais instituições financeiras. Esse valor que
                você deixou de pagar em taxas, juros e tarifas ou que recebeu a
                mais em rentabilidade nos seus investimentos, fica no seu bolso.
                Assim o seu poder de compra aumenta e impacta toda a comunidade.
                Fonte dos dados: Banco Central, Febraban e AMBIMA.
                <span
                  dangerouslySetInnerHTML={{
                    __html: " ",
                  }}
                />
              </span>
            </div>
            <div className="home-container25">
              <span className="Exo2-H5 home-text018">
                03.
                <span
                  dangerouslySetInnerHTML={{
                    __html: " ",
                  }}
                />
              </span>
              <span className="Exo2-T3 home-text019">
                Juntos criamos novas oportunidades em um ciclo sem fim.
              </span>
              <span className="Exo2-T4 home-text020">
                O valor gerado pela Economia da Cooperação fomenta o surgimento
                de novos negócios, promove a criação de novas oportunidades de
                trabalho que consequentemente, impacta de forma positiva na
                renda das pessoas, criando um ciclo virtuoso que desenvolve toda
                a economia local.
                <span
                  dangerouslySetInnerHTML={{
                    __html: " ",
                  }}
                />
              </span>
            </div>
          </div>
        </div>
      </div>
      <div className="home-separador1"></div>
      <div className="home-seo-3">
        <div className="home-container26">
          <div className="home-container27">
            <iframe
              src="https://www.youtube.com/embed/LdrV6A95sqw?si=I6IgGlCny53i2Etl"
              className="home-iframe2"
            ></iframe>
          </div>
        </div>
      </div>
      <div className="home-seo-4">
        <div className="home-container28 BoxShadow">
          <img
            alt="image"
            src="/lp/economiadacooperacao/ele%20bola%20gradiente%203-600h.png"
            className="home-image19 ElementoHoverEsquerda"
          />
          <div className="home-container29">
            <img
              alt="image"
              src="/lp/economiadacooperacao/foto%20valnildo-1200w.png"
              className="home-image20"
            />
            <div className="home-container30">
              <span className="home-text021 Exo2-T2">Vanildo Leoni</span>
              <span className="home-text022 Exo2-T3">
                Diretor Executivo na Viacredi
              </span>
            </div>
          </div>
          <div className="home-container31">
            <span className="home-text023 Exo2-T1">
              A Economia da Cooperação tem um poder multiplicador e exponencial.
              Todos ganham e se fortalecem mutuamente.
            </span>
            <span className="home-text024 Exo2-T1">
              É o cooperativismo posto em prática.
              <span
                dangerouslySetInnerHTML={{
                  __html: " ",
                }}
              />
            </span>
            <span className="home-text025 Exo2-T3">
              <span className="home-text026">
                Este impacto é percebido nas inúmeras histórias de vidas
                transformadas, nos sonhos realizados e em cada oportunidade
                gerada. Afinal, o nosso objetivo não é fortalecer apenas a
                economia, mas também os laços que nos unem.
              </span>
              <span className="Exo2-Tex3Bkp">
                <span
                  dangerouslySetInnerHTML={{
                    __html: " ",
                  }}
                />
              </span>
              <br className="Exo2-Tex3Bkp"></br>
              <br className="Exo2-Tex3Bkp"></br>
              <span className="Exo2-Tex3Bkp">
                Acreditamos que ao agir assim, colocamos em prática o nosso
                compromisso de criar um futuro melhor e mais próspero para
                todos.”
              </span>
            </span>
          </div>
        </div>
        <div className="home-container32">
          <h1 className="home-text031 Exo2-H4">Depoimentos</h1>
          <span className="Exo2-T3">
            Perguntamos para os nossos cooperados sobre alguns dos diferenciais
            da Viacredi. Confira.
          </span>
          <div className="home-container33">
            <div className="home-container34">
              <div className="home-container35">
                <iframe
                  src="https://www.youtube.com/embed/LjP1IVo2bcE?si=ych0RGBs4Y3JTVX3"
                  className="home-iframe3"
                ></iframe>
              </div>
              <span className="home-text033 Exo2-T3">
                <span className="home-text034">Vitor Pacheco Assis</span>
                <span>, de Curitiba (PR)</span>
              </span>
            </div>
            <div className="home-container36">
              <div className="home-container37">
                <iframe
                  src="https://www.youtube.com/embed/LI9HUUO5WTI?si=V61xkshn7QoDMos3"
                  className="home-iframe4"
                ></iframe>
              </div>
              <span className="home-text036 Exo2-T3">
                <span className="home-text037">Júlia Amado</span>
                <span>, de Blumenau (SC)</span>
              </span>
            </div>
          </div>
        </div>
      </div>
      <div className="home-seo-5">
        <div className="home-container38">
          <span className="home-text039 Exo2-H4">
            <span>
              Quando você coopera,
              <span
                dangerouslySetInnerHTML={{
                  __html: " ",
                }}
              />
            </span>
            <br></br>
            <span>você sai da teoria e vem para a prática</span>
          </span>
          <span className="home-text043 Exo2-T3">
            <span>
              Vivemos em um mundo repleto de desafios e sonhamos em construir um
              futuro melhor. Quando cooperamos, transformamos nosso sonho em
              realidade.
              <span
                dangerouslySetInnerHTML={{
                  __html: " ",
                }}
              />
            </span>
            <br></br>
            <br></br>
            <span>
              Cooperar começa por um interesse e cuidado consigo mesmo, e logo
              se estende para todas as pessoas e o planeta. Se você é cooperado,
              pode ter certeza que já está contribuindo para um mundo melhor,
              com menos desigualdade e mais oportunidades de desenvolvimento
              para todos.
              <span
                dangerouslySetInnerHTML={{
                  __html: " ",
                }}
              />
            </span>
          </span>
          <img
            alt="image"
            src="/lp/economiadacooperacao/fundo_predios.svg"
            className="home-image21"
          />
        </div>
      </div>
      <div className="home-seo-6">
        <div className="home-container39">
          <img
            alt="image"
            src="/lp/economiadacooperacao/objetivos-1200w.png"
            className="home-image22"
          />
          <div className="home-container40">
            <span className="home-text048 Exo2-T2">
              <span>
                A
                <span
                  dangerouslySetInnerHTML={{
                    __html: " ",
                  }}
                />
              </span>
              <span className="home-text050">Viacredi</span>
              <span>
                {" "}
                tem em sua essência o compromisso com o desenvolvimento
                sustentável.
                <span
                  dangerouslySetInnerHTML={{
                    __html: " ",
                  }}
                />
              </span>
            </span>
          </div>
        </div>
        <img
          alt="image"
          src="/lp/economiadacooperacao/external/grandiente.svg"
          className="home-image23"
        />
      </div>
      <div className="home-seo-7">
        <div className="home-container41">
          <div className="home-container42 BoxShadow">
            <img
              alt="image"
              src="/lp/economiadacooperacao/Secao7/fundo%20pin-600h.png"
              className="home-image24"
            />
            <div className="home-container43">
              <span className="home-text052 Exo2-H5">
                <span>Saiba quanto você já conquistou </span>
                <span>com a sua Economia da Cooperação </span>
              </span>
              <span className="home-text055 Exo2-T3">
                <span className="home-text056">
                  Encontre o Posto de Atendimento mais próximo e descubra o
                  quanto você economizou em 2023.
                </span>
                <br></br>
              </span>
              <a
                href="https://www.viacredi.coop.br/rede-de-atendimento"
                target="_blank"
                rel="noreferrer noopener"
                className="home-link06"
              >
                <div className="home-container44">
                  <span className="home-text058 OpenSans-T4">
                    <span className="home-text059">
                      Clique aqui
                      <span
                        dangerouslySetInnerHTML={{
                          __html: " ",
                        }}
                      />
                    </span>
                    <span>para acessar nossa rede de atendimento</span>
                  </span>
                </div>
              </a>
            </div>
          </div>
          <div className="home-container45 BoxShadow">
            <img
              alt="image"
              src="/lp/economiadacooperacao/Secao7/imagem%2011-1200w.png"
              className="home-image25"
            />
            <div className="home-container46">
              <span className="home-text061 Exo2-H5">
                <span>Juntos, você sabe né?!</span>
                <br></br>
                <span>Somos mais fortes.</span>
              </span>
              <span className="home-text065 Exo2-Tex3Bkp Exo2-T3">
                <span className="home-text066">
                  No Brasil já somos mais de 20,4 milhões de pessoas
                  cooperando*. E aqui na Viacredi já somamos mais de 950 mil
                  cooperados.
                </span>
                <br></br>
                <span className="home-text068"></span>
                <br></br>
                <span className="home-text070"></span>
                <span>*Dados do Anuário do Cooperativismo 2023</span>
              </span>
            </div>
          </div>
        </div>
      </div>
      <div className="home-footer-1">
        <div className="home-container47">
          <div className="home-container48">
            <span className="home-text072 Exo2-T3">
              <span>MAIS SOBRE A VIACREDI</span>
              <br></br>
            </span>
            <a
              href="https://forms.office.com/Pages/ResponsePage.aspx?id=dPYVfj-FCEeCcXWwiDPrjGFEm4L84rdEuE369cH8xHRUOVcwOUlRRzVWN0VSUDFPMFhZQTZOREowQy4u"
              target="_blank"
              rel="noreferrer noopener"
              className="home-link07 OpenSans-T4"
            >
              Seja um Fornecedor
            </a>
            <a
              href="https://www.viacredi.coop.br/privacidade-e-seguranca"
              target="_blank"
              rel="noreferrer noopener"
              className="home-link08 OpenSans-T4"
            >
              Privacidade e segurança
            </a>
            <a
              href="https://www.viacredi.coop.br/segunda-via-e-atualizacao-de-boletos"
              target="_blank"
              rel="noreferrer noopener"
              className="home-link09 OpenSans-T4"
            >
              Segunda via e atualização de boletos
            </a>
            <a
              href="https://www.viacredi.coop.br/trabalhe-conosco"
              target="_blank"
              rel="noreferrer noopener"
              className="home-link10 OpenSans-T4"
            >
              Trabalhe Conosco
            </a>
            <a
              href="https://www.viacredi.coop.br/noticias"
              target="_blank"
              rel="noreferrer noopener"
              className="home-link11 OpenSans-T4"
            >
              Notícias
            </a>
            <a
              href="https://www.viacredi.coop.br/bens-a-venda"
              target="_blank"
              rel="noreferrer noopener"
              className="home-link12 OpenSans-T4"
            >
              Bens à venda
            </a>
            <a
              href="https://www.viacredi.coop.br/mapa-do-site"
              target="_blank"
              rel="noreferrer noopener"
              className="home-link13 OpenSans-T4"
            >
              Mapa do site
            </a>
            <a
              href="https://www.viacredi.coop.br/#opencookies"
              target="_blank"
              rel="noreferrer noopener"
              className="home-link14 OpenSans-T4"
            >
              Gerenciar Cookies
            </a>
          </div>
          <div className="home-container49">
            <span className="home-text075 Exo2-T3">
              <span>REDE DE ATENDIMENTO </span>
              <br></br>
            </span>
            <a
              href="https://forms.office.com/Pages/ResponsePage.aspx?id=dPYVfj-FCEeCcXWwiDPrjGFEm4L84rdEuE369cH8xHRUOVcwOUlRRzVWN0VSUDFPMFhZQTZOREowQy4u"
              target="_blank"
              rel="noreferrer noopener"
              className="home-link15 OpenSans-T4"
            >
              Postos de Atendimento
            </a>
            <a
              href="https://www.viacredi.coop.br/caixa-eletronico"
              target="_blank"
              rel="noreferrer noopener"
              className="home-link16 OpenSans-T4"
            >
              Caixa Eletrônico
            </a>
            <a
              href="https://www.viacredi.coop.br/regularizacao-de-dividas"
              target="_blank"
              rel="noreferrer noopener"
              className="home-link17 OpenSans-T4"
            >
              Regularização de dívidas
            </a>
            <a
              href="https://www.viacredi.coop.br/contato"
              target="_blank"
              rel="noreferrer noopener"
              className="home-link18 OpenSans-T4"
            >
              Contato
            </a>
          </div>
          <div className="home-container50">
            <span className="home-text078 Exo2-T3">
              <span>FALE CONOSCO</span>
              <br></br>
            </span>
            <div className="home-container51">
              <a
                href="https://www.viacredi.coop.br/contato"
                target="_blank"
                rel="noreferrer noopener"
                className="home-link19"
              >
                <div className="home-container52">
                  <img
                    alt="image"
                    src="/lp/economiadacooperacao/Footer/icon-square-email.svg"
                    className="home-image26"
                  />
                  <span className="home-text081 OpenSans-T4">E-mail</span>
                </div>
              </a>
              <a
                href="https://api.whatsapp.com/send?phone=5508006472200"
                target="_blank"
                rel="noreferrer noopener"
                className="home-link20"
              >
                <div className="home-container53">
                  <img
                    alt="image"
                    src="/lp/economiadacooperacao/Footer/whats-icon.svg"
                    className="home-image27"
                  />
                  <span className="home-text082 OpenSans-T4">WhatsApp</span>
                </div>
              </a>
            </div>
            <a
              href="https://www.viacredi.coop.br/#nuvidio-widget-button"
              target="_blank"
              rel="noreferrer noopener"
              className="home-link21"
            >
              <div className="home-container54">
                <img
                  alt="image"
                  src="/lp/economiadacooperacao/Footer/icon-libras.svg"
                  className="home-image28"
                />
                <span className="home-text083 OpenSans-T4">
                  Atendimento em Libras
                </span>
              </div>
            </a>
            <span className="home-text084 Exo2-T3">
              <span>SAC 0800 647 2200</span>
              <br></br>
            </span>
            <span className="home-text087 OpenSans-T4">
              <span>Postos de Atendimento</span>
              <br></br>
              <span>
                Fique atento: nossos números oficiais são apenas receptivos, a
                cooperativa não realiza nenhuma ligação por meio deles.
              </span>
              <br></br>
              <br></br>
              <span>
                Atendimento das 7h às 22h, de segunda a sexta e das 8h às 20h
                sábados, domingos e feriados.
              </span>
              <br></br>
              <span>Chamadas internacionais: 55 47 3381 8740</span>
              <br></br>
              <br></br>
              <span>Ouvidoria 0800 644 1100</span>
              <br></br>
              <span>Atendimento das 8h às 17h, de segunda a sexta</span>
              <br></br>
            </span>
          </div>
        </div>
      </div>
      <div className="home-footer-2">
        <div className="home-container55">
          <img
            alt="image"
            src="/lp/economiadacooperacao/Footer/logo-viacredi-white-footer.svg"
            className="home-image29"
          />
          <div className="home-container56">
            <div className="home-container57">
              <img
                alt="image"
                src="/lp/economiadacooperacao/Footer/svg-image-19.svg"
                className="home-image30"
              />
            </div>
            <div className="home-container58">
              <img
                alt="image"
                src="/lp/economiadacooperacao/Footer/svg-image-20.svg"
                className="home-image31"
              />
            </div>
            <div className="home-container59">
              <img
                alt="image"
                src="/lp/economiadacooperacao/Footer/svg-image-21.svg"
                className="home-image32"
              />
            </div>
            <div className="home-container60">
              <img
                alt="image"
                src="/lp/economiadacooperacao/Footer/svg-image-22.svg"
                className="home-image33"
              />
            </div>
            <div className="home-container61">
              <img
                alt="image"
                src="/lp/economiadacooperacao/Footer/svg-image-23.svg"
                className="home-image34"
              />
            </div>
          </div>
          <span className="home-text102">
            <span>Viacredi Cooperativa de Crédito</span>
            <br></br>
            <span>CNPJ 82.639.451/0001-38</span>
            <br></br>
            <br></br>
            <span>Rua Hermann Hering, 1125, Bom Retiro</span>
            <br></br>
            <span>CEP 89010-923, Blumenau/SC.</span>
            <br></br>
            <br></br>
            <span>2024 Sistema Ailos.</span>
            <br></br>
            <span>Todos os direitos reservados.</span>
          </span>
        </div>
      </div>
    </div>
  );
};

export default Home;
